// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "Slider") {
    $this.Slider();
  }else if($this.data('section') == "ProductCarousel") {
    $this.ProductCarousel();
  }else if($this.data('section') == "TestimonialSection") {
    $this.TestimonialSection();
  }else if($this.data('section') == "AboutInfo") {
    $this.AboutInfo();
  }else if($this.data('section') == "TabProductCarousel") {
    $this.TabProductCarousel();
  }else if($this.data('section') == "HeaderSection") {
    $this.HeaderSection();
  }else if($this.data('section') == "BrandLogo") {
    $this.BrandLogo();
  }else if($this.data('section') == "FeaturedProduct") {
    $this.FeaturedProduct();
  }else if($this.data('section') == "LatestBlog") {
    $this.LatestBlog();
  }else if($this.data('section') == "MasonryMultipleBanner") {
    $this.MasonryMultipleBanner();
  }else if($this.data('section') == "MasonryProduct") {
    $this.MasonryProduct();
  }else if($this.data('section') == "MultipleBanner") {
    $this.MultipleBanner();
  }else if($this.data('section') == "PortfolioTemplate") {
    $this.PortfolioTemplate();
  }else if($this.data('section') == "PortfolioTemplateGrid") {
    $this.PortfolioTemplateGrid();
  }else if($this.data('section') == "RelatedProduct") {
    $this.RelatedProduct();
  }else if($this.data('section') == "SingleBanner") {
    $this.SingleBanner();
  }else if($this.data('section') == "TeamMember") {
    $this.TeamMember();
  }else if($this.data('section') == "VideoBanner") {
    $this.VideoBanner();
  }else{}   
}

// Slideshow active js
$.fn.Slider = function() {
  /*-----------------------------------------------
  15. Home Slider
-------------------------------------------------*/
  $('.slider__activation__wrap').owlCarousel({
    loop: true,
    margin:0,
    nav:true,
    rtl:true,
    autoplay: true,
    navText: [ '<i class="zmdi zmdi-chevron-left"></i>', '<i class="zmdi zmdi-chevron-right"></i>' ],
    autoplayTimeout: 10000,
    items:1,
    dots: false,
    lazyLoad: true,
    autoplay: false,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:1
      },
      800:{
        items:1
      },
      1024:{
        items:1
      },
      1200:{
        items:1
      },
      1400:{
        items:1
      },
      1920:{
        items:1
      }
    }
  });
  
  $("img.lazyload").lazyload();
};

// Featured product with carousel active js
$.fn.ProductCarousel = function() {
  $('.popular__product__wrap').slick({
    speed: 700,
    arrows: true,
    dots: false,
    slidesToScroll: 1,
    prevArrow: '<i class="zmdi zmdi-chevron-left"></i>',
    nextArrow: '<i class="zmdi zmdi-chevron-right"></i>'
  });
  $("img.lazyload").lazyload();
};

// Testimonial active js
$.fn.TestimonialSection = function() {
  /*-----------------------------------------------
  17. Testimonial Wrap
-------------------------------------------------*/
  $('.testimonial__wrap').owlCarousel({
    loop: true,
    margin:0,
    nav:false,
    rtl:true,
    autoplay: false,
    navText: false,
    autoplayTimeout: 10000,
    items:1,
    dots: false,
    lazyLoad: true,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:1
      },
      800:{
        items:1
      },
      1024:{
        items:1
      },
      1200:{
        items:1
      },
      1400:{
        items:1
      },
      1920:{
        items:1
      }
    }
  });
  
  $("img.lazyload").lazyload();
};

// About Info active js
$.fn.AboutInfo = function() {
  $('.video-popup').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    zoom: {
      enabled: true,
    }
  });
  $("img.lazyload").lazyload();
};

// Tab with product carousel active js
$.fn.TabProductCarousel = function() {
  var $carouseTab = $('[data-owl-carousel]');
  var $OwlTabProductCarousel = $('.product-slider-active');

  if ($carouseTab.length) {
    $carouseTab.each(function() {
      $(this).owlCarousel($(this).data('owl-carousel'));
    });
  }

  $OwlTabProductCarousel.owlCarousel();
  
  $("img.lazyload").lazyload();
};

// Header active js
$.fn.HeaderSection = function() {
  /*------------------------------------    
  10. Toogle Menu
--------------------------------------*/
  $('.toggle__menu').on('click', function() {
    $('.offsetmenu').addClass('offsetmenu__on');
    $('.body__overlay').addClass('is-visible');

  });

  $('.offsetmenu__close__btn').on('click', function() {
    $('.offsetmenu').removeClass('offsetmenu__on');
    $('.body__overlay').removeClass('is-visible');
  });
  
  /*------------------------------------    
  09. Search Bar
--------------------------------------*/ 
  $( '.search__open' ).on( 'click', function () {
    $( 'body' ).toggleClass( 'search__box__show__hide' );
    return false;
  });

  $( '.search__close__btn .search__close__btn_icon' ).on( 'click', function () {
    $( 'body' ).toggleClass( 'search__box__show__hide' );
    return false;
  });


  /*------------------------------------    
  11. Shopping Cart Area
--------------------------------------*/
  $('.cart__menu_2').on('click', function() {
    $('.shopping__cart').addClass('shopping__cart__on');
    $('.body__overlay').addClass('is-visible');

  });

  $('.offsetmenu__close__btn').on('click', function() {
    $('.shopping__cart').removeClass('shopping__cart__on');
    $('.body__overlay').removeClass('is-visible');
  });

  $('.cart__menu').on('click', function() {
    setTimeout(function () {
      $('.shopping__cart').addClass('shopping__cart__on');
      $('.body__overlay').addClass('is-visible');
    },1400);
    $(this).addClass('loading add-item');
    setTimeout(function () {
      $('.cart__menu').removeClass('loading');
    },800);
    setTimeout(function () {
      $('.cart__menu').removeClass("add-item");
    },1500);

  });
  
  /* Mega Menu */	
    $('.megamenu-li').parent('ul').addClass('mega_dropdown');
    $('.mega_dropdown').parent('li').addClass('mega-menu-drop');
  
  /*------------------------------------    
  12. Filter Area
--------------------------------------*/

    $('.filter__menu').on('click', function() {
      $('.filter__wrap').addClass('filter__menu__on');
      $('.body__overlay').addClass('is-visible');

    });

    $('.filter__menu__close__btn').on('click', function() {
      $('.filter__wrap').removeClass('filter__menu__on');
      $('.body__overlay').removeClass('is-visible');
    });



    /*------------------------------------    
  13. User Menu
--------------------------------------*/

    $('.user__menu').on('click', function() {
      $('.user__meta').addClass('user__meta__on');
      $('.body__overlay').addClass('is-visible');

    });

    $('.offsetmenu__close__btn').on('click', function() {
      $('.user__meta').removeClass('user__meta__on');
      $('.body__overlay').removeClass('is-visible');
    });



    /*------------------------------------    
  14. Overlay Close
--------------------------------------*/
    $('.body__overlay').on('click', function() {
      $(this).removeClass('is-visible');
      $('.offsetmenu').removeClass('offsetmenu__on');
      $('.shopping__cart').removeClass('shopping__cart__on');
      $('.filter__wrap').removeClass('filter__menu__on');
      $('.user__meta').removeClass('user__meta__on');
    });
  
  /* Remove Attr */
    $('.offsetmenu__close__btn a').removeAttr('href');
    $('.filter__box a, .filter__menu__close__btn a').removeAttr('href'); 
  
  $("img.lazyload").lazyload();

};

// Brand Logo active js
$.fn.BrandLogo = function() {
  $("img.lazyload").lazyload();
};

// Featured product active js
$.fn.FeaturedProduct = function() {
  $("img.lazyload").lazyload();
};

// Latest active js
$.fn.LatestBlog = function() {
  $("img.lazyload").lazyload();
};

// Masonry Multiple banner active js
$.fn.MasonryMultipleBanner = function() {
  $("img.lazyload").lazyload();
};

// Masonry Product active js
$.fn.MasonryProduct = function() {
  $("img.lazyload").lazyload();
};

// Multiple banner active js
$.fn.MultipleBanner = function() {
  $("img.lazyload").lazyload();
};

// Portfolio template active js
$.fn.PortfolioTemplate = function() {
  $("img.lazyload").lazyload();
};

// Portfolio template grid active js
$.fn.PortfolioTemplateGrid = function() {
  $("img.lazyload").lazyload();
};

// Related product active js
$.fn.RelatedProduct = function() {
  $("img.lazyload").lazyload();
};

// Single banner active js
$.fn.SingleBanner = function() {
  $("img.lazyload").lazyload();
};

// Team Member active js
$.fn.TeamMember = function() {
  $("img.lazyload").lazyload();
};

// Video banner active js
$.fn.VideoBanner = function() {
  $("img.lazyload").lazyload();
};



(function($) {
  "use strict";

  jQuery(document).ready(function(){



    /*-------------------------------------------
  02. wow js active
--------------------------------------------- */

    new WOW().init();

    
    
    /*--------------------------
  05. ScrollUp
---------------------------- */
    $.scrollUp({
      scrollText: '<i class="zmdi zmdi-chevron-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });



    /*---------------------------
  06. Tooltip
------------------------------*/    
    $('[data-toggle="tooltip"]').tooltip({
      animated: 'fade',
      placement: 'top',
      container: 'body'
    });



    /*-----------------------------------
  07. ScrollReveal Js Init
-------------------------------------- */

    window.sr = ScrollReveal({ duration: 800 , reset: true });
    sr.reveal('.foo');
    sr.reveal('.bar');



    /*-------------------------------------------------------
  08. Fixed Footer bottom script ( Newsletter )
--------------------------------------------------------*/

    var $newsletter_height = $(".htc__foooter__area");
    $('.fixed__footer').css({'margin-bottom': $newsletter_height.height() + 'px'});


    
    /*--------------------------------
  18. Magnific Popup
----------------------------------*/

    $('.video-popup').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      zoom: {
        enabled: true,
      }
    });

    $('.image-popup').magnificPopup({
      type: 'image',
      mainClass: 'mfp-fade',
      removalDelay: 100,
      gallery:{
        enabled:true, 
      }
    });




    /*-------------------------------
  20.  Plus Minus Button 
--------------------------------*/


    $(".cart-plus-minus").append('<div class="dec qtybutton">-</i></div><div class="inc qtybutton">+</div>');

    $(".qtybutton").on("click", function () {
      var $button = $(this);
      var oldValue = $button.parent().find("input").val();
      if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 1) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 1;
        }
      }
      $button.parent().find("input").val(newVal);
    });


    /*--------------------------
  21. jQuery scroll Nav
---------------------------- */
    $('.onepage--menu').onePageNav({
      scrollOffset: 0
    }); 		



    
    

    /* Match Heigh   
    $(function() {
      $('.product__list .tab-pane > div').matchHeight();
    });  
    $(function() {
      $('.best__product__list > div').matchHeight();
    }); 
    $(function() {
      $('.blog__wrap.latest-blog > div').matchHeight();
    });
    $(function() {
      $('.blog__wrap > .row > div').matchHeight();
    });
    $(function() {
      $('.shop__page .product__list > div').matchHeight();
    });
    $(function() {
      $('.portfolio-style > .row > div').matchHeight();
    });
*/

    /*---------------------
    countdown
  --------------------- */
    $('[data-countdown]').each(function() {
      var $this = $(this), finalDate = $(this).data('countdown');
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime('<span class="cdown day">%-D <p>Days</p></span> <span class="cdown hour">%-H <p>Hour</p></span> <span class="cdown minutes">%M <p>Min</p></span class="cdown second"> <span>%S <p>Sec</p></span>'));
      });
    }); 
    
    
    
    $("img.lazyload").lazyload();



  });

})(jQuery);



